import type { Cart, LineItem } from '~~/types/commercetools';

function getItemQty(product: LineItem): number {

  return product?.quantity ?? 0;

}

function getTotalItems(cart?: Cart): number {

  if (!cart) {

    return 0;

  }

  return cart.lineItems.reduce((sum, item) => sum + item.quantity, 0);

}

function getItemSku(product?: LineItem): string {

  return product?.variant?.sku ?? '';

}

function getItemName(product?: LineItem): string {

  return product?.name ?? '';

}

function getItemImage(product?: LineItem): string {

  return product?.variant?.images?.[0]?.url ?? '';

}

function getItems(cart?: Cart): LineItem[] {

  return cart?.lineItems ?? [];

}

export const cartGetters = {
  getItemQty,
  getItemSku,
  getTotalItems,
  getItemName,
  getItemImage,
  getItems,
};
